import React, { Component, PropTypes } from 'react';
import { login } from '../../services/APIAgent';
import { fadein } from '../decorators';
import classnames from 'classnames';

class Login extends Component {
    constructor(...props) {
        super(...props);

        this.state = {
            badCode: '',
            code: '',
            sending: false
        };

        this.input = null;
        this.onChange = this.onChange.bind(this);
        this.login = this.login.bind(this);
    }
    componentDidMount() {
        this.input.focus();
    }
    onChange({target}) {
        let { sending } = this.state;
        let { name, value: code } = target;

        if (!sending && name === 'code') this.setState({ code });
    }
    login(evt) {
        let { onLoggedIn } = this.props;
        let { code } = this.state;

        evt.preventDefault();
        this.input.blur();

        this.setState({ sending: true });

        login(code)
        .then(({error, handle, language}) => {
            this.setState({
                badCode: error ? this.state.code : '',
                code: '',
                sending: false
            });

            if (!error) onLoggedIn({
                error,
                handle,
                language,
                loggedIn: !error
            });
        })
        .catch(() => this.setState({
            badCode: code,
            code: '',
            sending: false
        }));
    }

    render() {
        let { visible } = this.props;
        let { badCode, code, sending } = this.state;

        let classes = classnames({
            'login': true,
            visible
        });

        return (<div className={classes}>
            <form onSubmit={ this.login }>
                <input placeholder="****" disabled={sending} ref={node => this.input = node} name="code" value={code} onChange={ this.onChange } autoComplete="off" autoCorrect="off" autoCapitalize="off" spellCheck={false} />
                <button disabled={sending} className="fa fa-chevron-right"></button>
                {badCode ? <div className="error"><span>{ badCode }</span><span className="fa fa-ban red"></span></div> : null }
            </form>
        </div>);
    }
}

Login.propTypes = {
    onLoggedIn: PropTypes.func.isRequired,
    visible: PropTypes.bool.isRequired
};

export default fadein(Login);


// WEBPACK FOOTER //
// ./src/components/login/index.js